export type TOrganizationDetails = OrganizationDetails[];

export interface OrganizationDetails {
  organizationId: number;
  organizationName: string;
}

export enum OrganizationTypeEnum {
  ClientPlan = 5,
}

export interface IOrgAttributes {
  attributeName: string;
  attributeValue: string;
  id: number;
  organizationId: number;
}

export interface WandaOrganizationDetails {
  benefitGroupId: number;
  benefitGroupName: string;
  clientPlanId: number;
  clientPlanName: string;
  privatePayId: number;
  privatePayName: string;
}
export function DefaultWandaOrganizationDetails() {
  return {
    benefitGroupId: 0,
    benefitGroupName: "",
    clientPlanId: 0,
    clientPlanName: "",
    privatePayId: 0,
    privatePayName: "",
  };
}
